import type { MqttConnector } from '@/types/auth'

export function isSameConnector(a: MqttConnector | null | undefined, b: MqttConnector): boolean {
  if (!a) return false
  return (
    a.clientId === b.clientId &&
    a.password === b.password &&
    a.userName === b.userName &&
    a.server.host === b.server.host &&
    a.server.port === b.server.port
  )
}
